import { instantDate } from '@lingoda/dates';
import { useClassStateStudentQuery } from '@lingoda/monolith-graphql';
import { getClassHasEnded, getClassHasStarted, getClassIsLive } from '@lingoda/classes-helpers';
import { useIntervalDate } from '@lingoda/hooks';
import { getClassIsMissed } from '../../utils';
import type { ClassId } from '../../types';

export const useClassStateStudent = (classId: ClassId | undefined) => {
    const { data, loading } = useClassStateStudentQuery({
        variables: { classId: classId as ClassId },
        skip: !classId,
    });
    // real instants: wall-time dates of a class spanning a DST fall-back share the same wall time
    const startDate = data && instantDate(data.class.startDate);
    const endDate = data && instantDate(data.class.endDate);
    const appointmentStatus = data?.class.appointment?.status;

    const currentTimeInstant = useIntervalDate('minute', { useInstant: true });

    return {
        loading,
        hasStarted: getClassHasStarted(startDate, currentTimeInstant),
        hasEnded: getClassHasEnded(endDate, currentTimeInstant),
        isLive: getClassIsLive(startDate, endDate, currentTimeInstant),
        isMissed: getClassIsMissed(appointmentStatus),
    };
};
